import React from 'react';

import { ConsumptionPageTypes } from 'src/types/consumption';
import { IconsSetType } from 'src/utils/constants/IconsConstants';

import * as customStyled from './styles';

export interface SocialButtonProps extends ConsumptionPageTypes.CommonUIProps {
  icon: any;
  type: IconsSetType;
  name: string;
  action?: (param: any) => void;
  id: string;
  fromThumbnail?: boolean;
  colour?: string;
  animate?: boolean;
  dislikeButton?: boolean;
  disable?: boolean;
  detailsPageFlag?: boolean;
  watchHistoryFlag?: boolean;
}

const SocialButton: React.FC<SocialButtonProps> = ({
  icon,
  name,
  type,
  action,
  id,
  fromThumbnail,
  animate,
  dislikeButton,
  disable,
  detailsPageFlag,
  watchHistoryFlag
}) => {
  return (
    <button
      title={name}
      css={[
        customStyled.button(fromThumbnail, dislikeButton),
        animate ? customStyled.likeAnimation : '',
        disable && customStyled.disable,
        detailsPageFlag && customStyled.detailsPageCtaWidth,
        watchHistoryFlag && customStyled.watchHistoryCss
      ]}
      onClick={action}
      data-testid={id}>
      {icon !== 'Play' ? (
        <span css={customStyled.iconStyle(icon, type)}></span>
      ) : null}
      <span css={customStyled.textStyle}>{name}</span>
    </button>
  );
};

export default SocialButton;
